export default __webpack_public_path__ + "static/media/1.cd5187a1.png";